"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _Calendar = _interopRequireDefault(require("@paprika/icon/lib/Calendar"));

var _input = _interopRequireDefault(require("@paprika/input"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var INPUT_PARSE_ERROR = "INPUT_PARSE";
var propTypes = {
  /** If the value of <input> is valid or not. */
  hasError: _propTypes["default"].bool,

  /** Date format used while entering and parsing user input. */
  dateFormat: _propTypes["default"].string,

  /** Selected date in moment object. */
  date: _propTypes["default"].instanceOf(_moment["default"]),

  /** Date format used while displaying date. It should be human-friendly and spelled out, default is MMMM DD,YYYY */
  humanFormat: _propTypes["default"].string,

  /** Callback when date is inputed. Will be called on blur or enter key press. */
  onChange: _propTypes["default"].func,

  /** Callback when user inputs date. Will be called after every key up event. */
  onChangePossibleDate: _propTypes["default"].func,

  /** Error callback. Will be called on blur or enter key press if inputted date can't be parsed. */
  onError: _propTypes["default"].func,

  /** Callback to be executed when the dateInput is clicked or activated by keyboard. */
  onClick: _propTypes["default"].func,

  /** Guard function. If it returns true - confirmation will be prevented. */
  denyConfirmation: _propTypes["default"].func,

  /** Callback when confirm */
  beforeConfirmation: _propTypes["default"].func
};

var noop = function noop() {};

var defaultProps = {
  hasError: false,
  dateFormat: "MM/DD/YYYY",
  date: null,
  humanFormat: undefined,
  onChange: noop,
  onChangePossibleDate: noop,
  onError: noop,
  onClick: noop,
  denyConfirmation: function denyConfirmation() {
    return false;
  },
  beforeConfirmation: noop
};

var DateInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var I18n = (0, _useI18n["default"])();
  var hasError = props.hasError,
      date = props.date,
      dateFormat = props.dateFormat,
      _props$humanFormat = props.humanFormat,
      humanFormat = _props$humanFormat === void 0 ? I18n.t("datePicker.confirmation_format") : _props$humanFormat,
      onChange = props.onChange,
      onChangePossibleDate = props.onChangePossibleDate,
      onError = props.onError,
      onClick = props.onClick,
      denyConfirmation = props.denyConfirmation,
      beforeConfirmation = props.beforeConfirmation,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["hasError", "date", "dateFormat", "humanFormat", "onChange", "onChangePossibleDate", "onError", "onClick", "denyConfirmation", "beforeConfirmation"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      hasParsingError = _React$useState2[0],
      setHasParsingError = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(date ? date.format(dateFormat) : ""),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      inputtedString = _React$useState4[0],
      setInputtedString = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(false),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      hasFocus = _React$useState6[0],
      setFocus = _React$useState6[1];

  _react["default"].useEffect(function () {
    if (date) {
      setInputtedString(date.format(dateFormat));
      setHasParsingError(false);
    }
  }, [dateFormat, date]);

  var hasErrorValue = hasError || hasParsingError;
  var inputText;

  if (hasFocus || denyConfirmation() || hasErrorValue) {
    inputText = inputtedString;
  } else {
    inputText = date ? date.format(humanFormat) : "";
  }

  function handleReset() {
    setHasParsingError(false);
    setInputtedString("");
    onChange(null);
  }

  function parseInput() {
    var newDate = (0, _moment["default"])(inputtedString, dateFormat);
    return newDate.isValid() ? newDate : (0, _moment["default"])(inputtedString);
  }

  function handleInputConfirm() {
    if (denyConfirmation()) {
      return;
    }

    beforeConfirmation();

    if (!inputtedString) {
      handleReset();
      return;
    }

    var newDate = parseInput();

    if (newDate.isValid()) {
      setHasParsingError(false);
      setInputtedString(newDate.format(dateFormat));
      if (!(0, _moment["default"])(newDate).isSame(date)) onChange(newDate);
    } else {
      setHasParsingError(true);
      onError({
        type: INPUT_PARSE_ERROR,
        value: inputtedString
      });
    }
  }

  function handleKeyUp(event) {
    if (event.key === "Enter") {
      handleInputConfirm();
    } else {
      var updatedPossibleDate = parseInput();
      onChangePossibleDate(updatedPossibleDate);
    }
  }

  function handleInputChange(e) {
    setInputtedString(e.target.value);
  }

  function handleClick() {
    if (!restProps.isReadOnly) {
      onClick();
    }
  }

  function handleInputBlur(e) {
    if ("onBlur" in restProps) {
      restProps.onBlur(e);
    }

    window.requestAnimationFrame(function () {
      setFocus(false);
      handleInputConfirm();
    });
  }

  function handleFocus(e) {
    setFocus(true);

    if ("onFocus" in restProps) {
      restProps.onFocus(e);
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_input["default"], (0, _extends2["default"])({
    icon: /*#__PURE__*/_react["default"].createElement(_Calendar["default"], null)
  }, restProps, {
    onChange: handleInputChange,
    onClick: handleClick,
    onKeyUp: handleKeyUp,
    ref: ref,
    value: inputText,
    onFocus: handleFocus,
    onBlur: handleInputBlur,
    hasError: hasErrorValue
  }));
});

DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;
var _default = DateInput;
exports["default"] = _default;
//# sourceMappingURL=DateInput.js.map